import Link from 'next/link'

interface LinkProps {
  href: string
  bg: 'success' | 'primary'
  style?: 'outline' | 'block'
  classes?: string[]
  children: JSX.Element | string
}
export default function CustomLink({
  href,
  bg,
  style = 'block',
  classes,
  children,
}: LinkProps) {
  if (style === 'block') {
    return (
      <Link
        href={href}
        className={`${
          bg === 'success' ? 'bg-success text-primary' : 'bg-primary text-white'
        }  rounded-md flex items-center justify-center ${classes?.join(' ')}`}>
        {children}
      </Link>
    )
  } else {
    return (
      <Link
        href={href}
        className={`${
          bg === 'success'
            ? 'text-success border-2 border-success'
            : 'text-primary border-2 border-primary'
        }  rounded-md ${classes?.join(' ')}`}>
        {children}
      </Link>
    )
  }
}
